import type { IConnectorStatus } from '@/types/connector'

export const CONNECTORS_LIST = {
  TITLE: 'Conectores',
  SEARCH_PLACEHOLDER: 'Buscar conectores por nombre...',
  NO_RESULTS: 'No se encontraron conectores que coincidan con tu búsqueda.',
  LOADING: 'Cargando conectores...',
  LAST_SYNC: 'Última sincronización:',
  NEVER_SYNCED: 'Nunca sincronizado',
  SYNCED_JUST_NOW: 'Sincronizado hace un momento',
  SYNCED_HOURS_AGO: (hours: number) => `Sincronizado hace ${hours}h`,
  SYNCED_DAYS_AGO: (days: number) => `Sincronizado hace ${days}d`,
  CONNECT: 'Conectar',
  MANAGE: 'Gestionar',
  COMING_SOON: 'Próximamente',
  STATUS: {
    completed: 'Completado',
    notStarted: 'No conectado',
    error: 'Error',
  } satisfies Record<NonNullable<IConnectorStatus>, string>,
  POPUP_CONNECT_ERROR: 'Error intentando conectar al proveedor de Oauth',
}

export const CONNECTION_SUCCESS = {
  TITLE: 'Conexión exitosa',
  SUBTITLE: 'Configuración OAuth completada',
  MESSAGE: 'Cierra esta ventana para completar el proceso de configuración.',
  BUTTON: 'Cerrar',
}

export const CONNECTION_FAILED = {
  TITLE: 'Conexión fallida',
  SUBTITLE: 'No se pudo completar la configuración OAuth',
  MESSAGE: 'Cierra esta ventana para intentar de nuevo o contacta soporte.',
  BUTTON: 'Cerrar',
}
